// extracted by mini-css-extract-plugin
export default {"container":"gA-z","dimension":"hA-z","dimensionLabels":"iA-z"};